import { render, staticRenderFns } from "./projectDetailsDialog.vue?vue&type=template&id=046c70c2&"
import script from "./projectDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./projectDetailsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports